import React from 'react';
import { Helmet } from 'react-helmet-async';
import PartnerForm from '../components/partner/PartnerForm';
import PartnerBenefits from '../components/partner/PartnerBenefits';

export default function PartnerWithUs() {
  return (
    <>
      <Helmet>
        <title>Partner With Us - Parakh Services</title>
        <meta 
          name="description" 
          content="Join Parakh Services as a technician partner. Great earning potential, flexible hours, and continuous growth opportunities." 
        />
      </Helmet>

      <div className="partner-section">
        <div className="mobile-container">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Partner With Us
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Join our network of skilled technicians and grow your career with India's trusted appliance repair service
            </p>
          </div>

          <div className="partner-grid">
            <PartnerBenefits />
            <PartnerForm />
          </div>
        </div>
      </div>
    </>
  );
}